"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAwsCredentials = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateAwsCredentials = (0, validation_1.properties)({
    accessKeyId: (0, validation_1.text)(),
    secretKey: (0, validation_1.text)(),
    sessionToken: (0, validation_1.text)(),
});
//# sourceMappingURL=AwsCredentials.js.map